<template>
  <div id="role">
    <el-row>
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <span>请选择订单号:</span>
        </el-form-item>
        <el-form-item>
          <el-select v-model="orderId" placeholder="请选择">
            <el-option v-for="item in orders" :key="item.id" :label="item.id" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="startloading"
            type="primary"
            @click="startChooes"
            v-if="orders.length!=0&&orderId!=''"
            :disabled="isChoose"
          >修改</el-button>
          <span v-if="orders.length==0">无角色</span>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      postApi: {
        crud: "",
        info: {}
      },

      roleName: "",

      formState: "", //0 常规 1修改

      roles: [],

      roleApps: []
    };
  },
  created: async function() {
    let res = await this.$doPost("/api/role", this.postApi);
    if (res.msgCode == 0) {
      this.roleApps = res.result.info;
    }
  },
  methods: {
    getRolesName: async function() {
      let res = await this.$doPost("/api/role", this.postApi);
      if (res.msgCode == 0) {
        this.roleApps = res.result.info;
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/mysys/Role.vue